export default {
	VENEER: 0,
	SPLICED: 1,
	TIMBER: 2,
	VIRTUAL: 3
}